import { useState, useEffect } from "react";
import React from "react";
import FormController from "../Utils/FormController";
import Button from "../Components/FormComponents/Button";
import { departments } from "../Data/deptData";
import { VacancyCard } from "./VacancyCard";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { fetchRecruitData } from "../Actions/actions"; // Adjust the import path as needed
import { getAccessToken } from "../Actions/actions"; // Adjust path
import "../App.css";

const Careers = () => {
  const [filters, setFilters] = useState({
    department: "",
    location: "",
  });
  const [locations, setLocations] = useState([]);
  const [vacancyData, setVacancyData] = useState();
  const [filteredVacancies, setFilteredVacancies] = useState();
  const [msg, setMsg] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [name]: value,
        ...(name === "department" ? { location: "All" } : {}), // Reset location when department changes
      };
      return updatedFilters;
    });

    if (name === "department") {
      setFilteredVacancies([
        { data: "Select a location and click filter to see vacancies." },
      ]);
      setMsg(true);
      // Convert department names to lowercase without spaces
      const normalizedDept = value.toLowerCase().replace(/\s+/g, "");

      // Find matching vacancies based on department
      const matchingVacancies = vacancyData?.filter(
        (vacancy) =>
          vacancy.Department_Name?.name?.toLowerCase().replace(/\s+/g, "") ===
          normalizedDept
      );
      const updatedLocations = [
        "All",
        ...new Set(
          matchingVacancies
            .map((vacancy) => vacancy.City)
            .filter((city) => city) // Removes falsy values like `""`, `null`, `undefined`
        ),
      ];

      setLocations(updatedLocations);
    }
  };

  const handleFilterClick = () => {
    let filteredData = vacancyData;

    // Normalize function for department comparison
    const normalizeText = (text) => text?.toLowerCase().replace(/\s+/g, "");

    // Check if department filter is not "ALL"
    if (filters.department !== "All") {
      filteredData = filteredData.filter((vacancy) => {
        const normalizedVacancyDept = normalizeText(
          vacancy.Department_Name?.name
        );
        const normalizedFilterDept = normalizeText(filters.department);
        return normalizedVacancyDept === normalizedFilterDept;
      });
    }

    // Check if location filter is not "ALL"
    if (filters.location !== "All") {
      filteredData = filteredData.filter(
        (vacancy) =>
          vacancy.City === filters.location || vacancy.mode === filters.location
      );
    }
    if (filteredData?.length > 0) {
      setFilteredVacancies(filteredData);
      setMsg(false);
    } else if (filteredData?.length === 0) {
      setFilteredVacancies([{ data: "No opportunities available." }]);
      setMsg(true);
    }
  };

  const handleClearFilters = () => {
    setFilters({
      department: "",
      location: "",
    });
    setLocations([]);
    setFilteredVacancies(vacancyData); // Reset to initial vacancy data
    setMsg(false);
  };

  // Initial setup - try to use existing token or get a new one if needed
  useEffect(() => {
    const fetchData = async () => {
      let token = localStorage.getItem("access_token");

      if (!token) {
        token = await getAccessToken();
      }

      if (token) {
        let data = await fetchRecruitData(token);

        // If token is invalid, refresh and retry once
        if (data?.code === "INVALID_TOKEN") {
          token = await getAccessToken();
          data = await fetchRecruitData(token);
        }
        // assume `data.data` is your array of jobs
        const allJobs = data?.data ?? [];
        // 1. remove the one whose Job_Opening_Name is exactly "Create your own role!"
        const filtered = allJobs.filter(
          (job) => job.Job_Opening_Name !== "Create your own role!"
        );
       

        setFilteredVacancies(filtered);
        setVacancyData(filtered);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container mt-5 d-flex flex-column align-items-center w-full max-w-[1440px] mx-auto">
      {/* Join Our Team Heading */}
      <h1 className="join-our-team-heading">JOIN OUR TEAM</h1>
      
      {/* Filter Form & Vacancies - Ensuring Same Width */}
      <div className="w-100" style={{ maxWidth: "1440px" }}>
        {/* Filter Section */}
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-2 w-100 text-center">
          {/* Department Dropdown */}
          <div
            className="d-flex flex-column align-items-center"
            style={{ maxWidth: "20rem" }}
          >
            <FormController
              control="dropdown"
              label="Department"
              name="department"
              options={departments}
              value={filters.department}
              onChange={handleFilterChange}
              placeholderTitle={"Department"}
            />
          </div>

          {/* Location Dropdown */}
          <div
            className="d-flex flex-column align-items-center"
            style={{ width: "20rem" }}
          >
            <FormController
              control="dropdown"
              label="Location"
              name="location"
              options={locations?.map((location) => ({
                label: location,
                value: location,
              }))}
              value={filters.location}
              onChange={handleFilterChange}
              placeholderTitle={"Location"}
            />
          </div>

          {/*  Button */}
          <div className="d-flex align-items-center justify-content-center gap-2">
            <Button
              onClick={handleFilterClick}
              color="primary"
              icon={faAngleRight}
              variant="filter"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0",
                marginBottom: "0.2rem",
                marginLeft: "-0.9rem",
                marginRight: "0.5rem"
              }}
            ></Button>

            {/* Clear Button */}
            <Button
              onClick={handleClearFilters}
              className="btn w-100 w-md-auto"
              variant="clear"
              label="CLEAR"
              style={{
                textDecoration: "underline",
                textUnderlineOffset: "4px",
                // fontSize: "18px"
              }}
            />
          </div>
        </div>

        {/* Separator Line Before Vacancies */}
        <hr className="my-0" style={{ borderTop: "2px solid #ddd" }} />

        {/* Vacancy List */}
        <VacancyCard
          filteredVacancies={filteredVacancies}
          filters={filters}
          msg={msg}
          setMsg={setMsg}
        />
      </div>
    </div>
  );
};

export default Careers;
